import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {PermissionEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {usePermissionAction} from "./usePermissionAction";

const ALL_PERMISSION_ACTIONS = [] as const;

export type PermissionAction = typeof ALL_PERMISSION_ACTIONS[number];

export type PermissionActionMenuDropdownProps = {
  permission: PermissionEntity
  actions?: PermissionAction[]
  onActionClick?: (action: PermissionAction) => void
  showEmpty?: boolean
}

export const PermissionActionMenuDropdown = (props: PermissionActionMenuDropdownProps) => {
  const {
    permission,
    actions = ALL_PERMISSION_ACTIONS,
    onActionClick,
    showEmpty = true
  } = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const visibleActions: Set<PermissionAction> = useMemo(() => {
    const enabledActions = new Set<PermissionAction>()
    const actionsSet = actions ? new Set<PermissionAction>(actions) : new Set<PermissionAction>()
    return enabledActions
  }, [permission, actions, hasAccess])

  const {
    onPermissionActionClick
  } = usePermissionAction()

  const _onActionClick = useCallback((action: PermissionAction) => {
    if (onActionClick) {
      onActionClick(action)
    } else {
      onPermissionActionClick(permission, action)
    }
  }, [onActionClick, onPermissionActionClick, permission])

  return (
    <>
      {(showEmpty && visibleActions.size === 0) &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
    </>
  )
}
